import { ajaxSend } from 'api/api';
import type { NodeDataT } from 'fable/flowEditor';

import type { FlowChatActionT, FlowChatGetAllPayloadT } from './types';

export function flowGetAll(
  payload: FlowChatGetAllPayloadT = { channel: 'widgetchat' },
) {
  return ajaxSend<NodeDataT<FlowChatActionT[]>>({
    path: `/v1/flows?channel=${payload.channel}`,
  });
}
